module.exports = require("core-js/modules/es.typed-array.to-string.js");